<template>
  <div>
    <div class="irv-context">
      <div class="irv-context__head">
        <v-icon size="small" color="primary" class="mr-1">mdi-link-variant</v-icon>
        {{ verif.length }} {{ $t('verif_machines.label') }} · {{ $filters.capitalize($t('verif_machines.linked_to_report')) }}
      </div>
      <div class="irv-context__chips">
        <v-chip v-for="v in verif" :key="v.pk" size="small" variant="tonal" color="primary" label class="mr-1 mb-1">
          <v-icon start size="x-small">mdi-check-circle</v-icon>
          {{ localized(v, 'verification_title') }}
        </v-chip>
      </div>
    </div>
    <InterventionReportEdition
        :prefilled='true'
        @saved='newRepCreated'
        />
  </div>
</template>

<script>
import InterventionReportEdition from "@/views/InterventionReportEdition";


export default {
  name: 'InterventionReportForVerif',
  components: {
    InterventionReportEdition,
  },
  props: {
    verif: {
    }
  },
  methods: {
    localized(item, field) {
      if (this.$store.getters.language === 'en' && item[field + '_en']) return item[field + '_en']
      return item[field]
    },
    newRepCreated(rep) {
      let verif_ids = this.verif.map(p => p.last_done_id)
      this.$store.dispatch('verif_dones/assignIntRep', {
        verif_ids: verif_ids,
        intervention_report_id: rep.pk,
      })
      this.$emit('saved', rep)

    },
  },
}
</script>

<style scoped>
.irv-context {
  background: #f6f7f9;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 8px;
}
.irv-context__head {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 6px;
}
.irv-context__chips {
  display: flex;
  flex-wrap: wrap;
  max-height: 96px;
  overflow-y: auto;
}
</style>
